class CartDrawer extends HTMLElement {
  constructor() {
    super();
    console.log('[CartDrawer DEBUG] Constructor called.');

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // Overlay listener will be (re)-attached in connectedCallback and after potential re-renders by CartDrawerItems
    this.setHeaderCartIconAccessibility();

    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (eventData) => {
      if (eventData && eventData.cartData && eventData.cartData.sections) {
        this.renderDrawerFromExternalUpdate(eventData.cartData);
      }
    });
  }

  connectedCallback() {
    // console.log('[CartDrawer DEBUG] connectedCallback executed.');
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      if (!overlay.dataset.listenerAttached) {
        // console.log('[CartDrawer DEBUG] Attaching overlay click listener in connectedCallback.');
        overlay.addEventListener('click', this.close.bind(this));
        overlay.dataset.listenerAttached = 'true';
      }
    } else {
      console.warn('[CartDrawer DEBUG] Overlay not found in connectedCallback.');
    }
    const closeButton = this.querySelector('.drawer__header .drawer__close');
    if (closeButton && !closeButton.dataset.listenerAttached) {
      // console.log('[CartDrawer DEBUG] Attaching header close button listener in connectedCallback.');
      closeButton.addEventListener('click', this.close.bind(this));
      closeButton.dataset.listenerAttached = 'true';
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('a[aria-controls="CartDrawer"]');
    if (cartLinks.length === 0) {
      // console.warn('CartDrawer: No cart trigger links found with aria-controls="CartDrawer".');
      return;
    }
    cartLinks.forEach(cartLink => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.removeEventListener('click', this.openCartDrawerHandler);
      this.openCartDrawerHandler = (event) => { event.preventDefault(); this.open(cartLink); }; // Store handler for removal
      cartLink.addEventListener('click', this.openCartDrawerHandler);
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    // console.log('[CartDrawer DEBUG] Open called.');
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNoteSummary = this.querySelector('#Details-CartDrawer summary');
    if (cartDrawerNoteSummary && !cartDrawerNoteSummary.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNoteSummary);
    }
    setTimeout(() => {
      this.classList.add('animate', 'active');
    }, 50);

    this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
        : this.querySelector('#CartDrawer');
      let focusElement = this.querySelector('.drawer__inner .drawer__close') || this.querySelector('.cart-item__name') || this.querySelector('.drawer__close');
      if (this.classList.contains('is-empty')) {
        focusElement = this.querySelector('.drawer__inner-empty a, .drawer__inner-empty button') || this.querySelector('.drawer__close');
      }
      if (containerToTrapFocusOn && focusElement) {
        trapFocus(containerToTrapFocusOn, focusElement);
      }
    }, { once: true });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    // console.log('[CartDrawer DEBUG] Close called.');
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNoteSummary) {
    cartDrawerNoteSummary.setAttribute('role', 'button');
    cartDrawerNoteSummary.setAttribute('aria-expanded', 'false');
    const detailsElement = cartDrawerNoteSummary.closest('details');
    if (detailsElement && detailsElement.querySelector('.cart__note')) {
      cartDrawerNoteSummary.setAttribute('aria-controls', detailsElement.querySelector('.cart__note').id || 'CartDrawer-Note');
    }
    cartDrawerNoteSummary.removeEventListener('click', this.toggleSummaryAriaExpanded);
    this.toggleSummaryAriaExpanded = (event) => {
        const details = event.currentTarget.closest('details');
        const isOpen = details.hasAttribute('open');
        event.currentTarget.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    };
    cartDrawerNoteSummary.addEventListener('click', this.toggleSummaryAriaExpanded);
  }
  
  updateCartIconBubble(cartData) {
    // console.log('[CartDrawer DEBUG] updateCartIconBubble START. cartData items array length:', cartData && cartData.items ? cartData.items.length : 'N/A');
    const cartIconBubbleSectionHTML = cartData && cartData.sections && cartData.sections['cart-icon-bubble'];
    
    if (cartIconBubbleSectionHTML) {
      // console.log('[CartDrawer DEBUG] updateCartIconBubble: HTML for cart-icon-bubble found:', cartIconBubbleSectionHTML.substring(0, 100) + '...');
      
      const bubbleContainers = [
        document.getElementById('cart-icon-bubble-container'),
        document.getElementById('cart-icon-bubble-container-mobile'),
        document.getElementById('cart-icon-bubble') // Fallback for older structure if any
      ].filter(el => el !== null); // Filter out nulls if an ID doesn't exist

      if (bubbleContainers.length > 0) {
        bubbleContainers.forEach(bubbleContainer => {
          // console.log('[CartDrawer DEBUG] updateCartIconBubble: Target container found:', bubbleContainer.id, 'Current display:', bubbleContainer.style.display);
          bubbleContainer.innerHTML = cartIconBubbleSectionHTML;
          
          const hasItems = cartData && cartData.items && cartData.items.length > 0;
          let displayStyle = 'none';
          if (hasItems) {
            if (bubbleContainer.id === 'cart-icon-bubble' && bubbleContainer.tagName === 'SPAN') {
              displayStyle = 'inline-block';
            } else if (bubbleContainer.id === 'cart-icon-bubble-container' || bubbleContainer.id === 'cart-icon-bubble-container-mobile') { 
              displayStyle = 'flex'; 
            } else {
              displayStyle = 'block'; 
            }
          }
          bubbleContainer.style.display = displayStyle;
          // console.log('[CartDrawer DEBUG] updateCartIconBubble: Container HTML updated for', bubbleContainer.id, '. New display style applied:', displayStyle, 'final display:', bubbleContainer.style.display);
        });
      } else {
        // console.warn('[CartDrawer DEBUG] updateCartIconBubble: NO cart icon bubble containers found (cart-icon-bubble-container, cart-icon-bubble-container-mobile, or cart-icon-bubble).');
      }
    } else {
      // console.warn('[CartDrawer DEBUG] updateCartIconBubble: cart-icon-bubble HTML NOT in cartData.sections. cartData.sections keys:', cartData && cartData.sections ? Object.keys(cartData.sections) : 'N/A');
    }
    // console.log('[CartDrawer DEBUG] updateCartIconBubble END.');
  }

  updateEmptyState(cartData) {
    // console.log('[CartDrawer DEBUG] updateEmptyState START. cartData items array length:', cartData && cartData.items ? cartData.items.length : 'N/A');
    if (cartData && cartData.items) { // Check for items array directly
      if (cartData.items.length > 0) { // Use items array length
        this.classList.remove('is-empty');
        // console.log('[CartDrawer DEBUG] updateEmptyState: Removed "is-empty" class based on items.length.');
      } else {
        this.classList.add('is-empty');
        // console.log('[CartDrawer DEBUG] updateEmptyState: Added "is-empty" class based on items.length.');
      }
    } else {
      console.warn('[CartDrawer DEBUG] updateEmptyState: cartData or cartData.items is missing. Could not determine empty state.');
      // Optionally, decide a default behavior e.g., assume empty if data is incomplete
      // this.classList.add('is-empty'); 
    }
    // console.log('[CartDrawer DEBUG] updateEmptyState END.');
  }

  renderDrawerFromExternalUpdate(cartData) {
    // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate START.');
    // console.log('[CartDrawer DEBUG] Calling updateCartIconBubble from renderDrawerFromExternalUpdate.');
    this.updateCartIconBubble(cartData);
    // console.log('[CartDrawer DEBUG] Calling updateEmptyState from renderDrawerFromExternalUpdate.');
    this.updateEmptyState(cartData);

    const drawerSectionHTML = cartData.sections && cartData.sections['cart-drawer'];
    if (!drawerSectionHTML) {
      console.warn('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: cart-drawer section HTML NOT found. Sections keys:', cartData.sections ? Object.keys(cartData.sections) : 'N/A');
      return;
    }
    // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: cart-drawer section HTML found.');

    const tempDOM = new DOMParser().parseFromString(drawerSectionHTML, 'text/html');
    const newCartDrawerElement = tempDOM.querySelector('cart-drawer');

    if (!newCartDrawerElement) {
      console.warn('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: <cart-drawer> element NOT found in fetched HTML.');
      return;
    }
    // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: <cart-drawer> element found in fetched HTML.');

    const liveDrawerInner = this.querySelector('.drawer__inner');
    if (!liveDrawerInner) {
      console.warn('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: .drawer__inner NOT found in the live cart drawer.');
      return;
    }
    // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: .drawer__inner found in live DOM.');

    const newDrawerInnerContent = newCartDrawerElement.querySelector('.drawer__inner');

    if (!newDrawerInnerContent) {
      console.warn('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: .drawer__inner HTML content NOT found in fetched <cart-drawer>. Cart item_count:', cartData.item_count);
      if (cartData.item_count === 0) {
        liveDrawerInner.innerHTML = '<div class="drawer__inner-empty"><p class="cart__empty-text">Your cart is currently empty.</p><a href="/collections/all" class="button">Continue shopping</a></div>';
        // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Injected default empty state HTML.');
      } else {
        console.error('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Critical - .drawer__inner HTML missing from fetched non-empty cart data.');
        return;
      }
    } else {
      // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Replacing .drawer__inner HTML.');
      liveDrawerInner.innerHTML = newDrawerInnerContent.innerHTML;
      // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: .drawer__inner HTML REPLACED.');
    }

    // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Starting re-initializations.');
    liveDrawerInner.querySelectorAll('quantity-input, cart-remove-button, cart-note, cart-drawer-items').forEach(el => {
      if (typeof customElements.upgrade === 'function') {
        customElements.upgrade(el);
      }
    });
    // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Custom elements upgraded.');

    const closeButtonInHeader = liveDrawerInner.querySelector('.drawer__header .drawer__close');
    if (closeButtonInHeader) {
      if (!this.closeDrawerHandler) {
        this.closeDrawerHandler = this.close.bind(this);
      }
      closeButtonInHeader.removeEventListener('click', this.closeDrawerHandler);
      closeButtonInHeader.addEventListener('click', this.closeDrawerHandler);
      // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Header close button listener re-attached.');
    } else {
       console.warn('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Header close button NOT found in new innerHTML.');
    }

    const cartDrawerNoteSummary = liveDrawerInner.querySelector('#Details-CartDrawer summary');
    if (cartDrawerNoteSummary) {
      this.setSummaryAccessibility(cartDrawerNoteSummary);
      // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Cart note summary accessibility re-set.');
    } else {
       console.warn('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Cart note summary NOT found in new innerHTML.');
    }

    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay && !overlay.dataset.listenerAttached) {
      overlay.addEventListener('click', this.close.bind(this));
      overlay.dataset.listenerAttached = 'true';
      // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Overlay listener re-attached (was missing data-listener-attached).');
    }

    if (this.classList.contains('active')) {
      // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Drawer is active, managing focus.');
    setTimeout(() => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? liveDrawerInner.querySelector('.drawer__inner-empty') || liveDrawerInner 
          : liveDrawerInner;

        let focusElement;
        if (this.classList.contains('is-empty')) {
          focusElement = liveDrawerInner.querySelector('.drawer__inner-empty a, .drawer__inner-empty button') || liveDrawerInner.querySelector('.drawer__close');
        } else {
          // Prefer focusing the close button first, then a cart item, then fallback to any close button in drawer__inner.
          focusElement = liveDrawerInner.querySelector('.drawer__header .drawer__close') || liveDrawerInner.querySelector('.cart-item__name') || liveDrawerInner.querySelector('.drawer__close');
        }
        
        if (containerToTrapFocusOn && focusElement) {
          trapFocus(containerToTrapFocusOn, focusElement);
          // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Focus trapped.');
        } else if (containerToTrapFocusOn) {
            const fallbackFocus = containerToTrapFocusOn.querySelector('button, a, input, [tabindex]:not([tabindex="-1"])');
            if (fallbackFocus) {
              trapFocus(containerToTrapFocusOn, fallbackFocus);
              // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Focus trapped on fallback.');
            } else {
              // console.warn('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: No focusable element found for trapFocus.');
            }
        } else {
            // console.warn('[CartDrawer DEBUG] renderDrawerFromExternalUpdate: Container to trap focus on not found.');
        }
      }, 100);
    }
    // console.log('[CartDrawer DEBUG] renderDrawerFromExternalUpdate END.');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
  // getSectionDOM might be part of original CartDrawer logic, keep if so.
  // For this specific update, it's not directly used by the subscriber.
  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  disconnectedCallback() {
    // console.log('[CartDrawer DEBUG] disconnectedCallback executed.');
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    // Clean up stored event handlers if any
    const cartLinks = document.querySelectorAll('a[aria-controls="CartDrawer"]');
    cartLinks.forEach(cartLink => cartLink.removeEventListener('click', this.openCartDrawerHandler));
    const closeButtonInHeader = this.querySelector('.drawer__header .drawer__close');
    if (closeButtonInHeader) closeButtonInHeader.removeEventListener('click', this.closeDrawerHandler);
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.removeEventListener('click', this.closeDrawerHandler);
     const cartDrawerNoteSummary = this.querySelector('#Details-CartDrawer summary');
    if(cartDrawerNoteSummary) cartDrawerNoteSummary.removeEventListener('click', this.toggleSummaryAriaExpanded);
  }
}

customElements.define('cart-drawer', CartDrawer);

// Ensure CartDrawerItems (extending CartItems) correctly handles its own updates.
// Its onCartUpdate (from CartItems) and getSectionsToRender will be key.
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    //console.log('[CartDrawerItems DEBUG] Constructor called.');
  }

  connectedCallback() {
    super.connectedCallback(); // Call CartItems' connectedCallback if it exists and is necessary
    // console.log('[CartDrawerItems DEBUG] connectedCallback executed.');
  }

  disconnectedCallback() {
    super.disconnectedCallback(); // Call CartItems' disconnectedCallback
    // console.log('[CartDrawerItems DEBUG] disconnectedCallback executed.');
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
